import { ComponentPropsWithoutRef, forwardRef, Ref } from "react";

import cx from "classnames";
import styles from "./List.module.scss";

/**
 * Props for the ListItem component
 * @extends ComponentPropsWithoutRef<"li">
 */
export type ListItemProps = ComponentPropsWithoutRef<"li">;

export const ListItem = forwardRef<HTMLLIElement, ListItemProps>(
  (props, ref: Ref<HTMLLIElement>) => {
    const { className, children, ...rest } = props;

    return (
      <li
        ref={ref}
        className={cx(styles["item"], className)}
        data-anv="list-item"
        {...rest}
      >
        {children}
      </li>
    );
  },
);

ListItem.displayName = "ListItem";
